/* 选择国际化配置的方案，
* 1、online：纯使用翻译平台的接口；更新无需发版
* 2、local： 纯本地化vue-i18n，从翻译平台导出语言包放置src\lang\gscPackages；更新需要发版
* online、local通过字典LANGUAGE_SOURCE配置，会通过单个字典接口queryDictionaryType接口返回，字段为LANGUAGE_SOURCE
*/
/* eslint-disable no-use-before-define */
import Vue from 'vue';
import store from '@/store/index';
import { getAppLanguageTypes, $t } from 'msct-web-sdk';
// local时使用
const langArr = [
    { languageType: 'zh', languageDesc: '中文', languageSort: 1 },
    { languageType: 'en', languageDesc: '英文-English', languageSort: 2 },
    { languageType: 'ja', languageDesc: '日语-日本語', languageSort: 3 },
    { languageType: 'ru', languageDesc: '俄语-Русский', languageSort: 4 },
    { languageType: 'th', languageDesc: '泰语-ภาษาไทย', languageSort: 5 },
    { languageType: 'pt', languageDesc: '葡萄牙语-Português', languageSort: 6 },
    { languageType: 'vi', languageDesc: '越南语-Tiếng Việt', languageSort: 7 },
    { languageType: 'ar', languageDesc: '阿拉伯语-لغة عربية', languageSort: 8 },
];
const languageTypeList = JSON.parse(localStorage.getItem('languageTypeList')) || langArr;// 先取缓存数据，缓存没有再取预置的数据

const getLanguage = (i18n) => new Promise((resolve) => {
    if (store.state.languageSource === 'online') {
        getAppLanguageTypes('G-GSC', process.env.VUE_APP_ENV === 'PROD' ? 'prod' : 'uat').finally(() => {
            Vue.prototype.$t = $t; // 使用国际化平台的翻译方法
            resolve();
        });
    } else { // local
        Vue.prototype.$t = (key) => // 兼容翻译平台方法
            i18n.t(key);
        localStorage.setItem('languageTypeList', JSON.stringify(languageTypeList)); // 本地化语言包
        resolve();
    }
});

export default getLanguage;
